import React from 'react';
import {Backdrop, Fade, Modal} from "@mui/material";
import {makeStyles} from "@mui/styles";
import {Elements} from "@stripe/react-stripe-js";
import CheckoutForm from "./CheckoutForm";
import {loadStripe} from "@stripe/stripe-js/pure";

const useStyles = makeStyles((theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'auto'
    }, paper: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    }
}));
const PaymentModal = ({payModal,closeModal, payThisMuch,billingDetails, setBilling, sendStripeToken}) => {
    const {stripeKey} = window;
    let stripePromise = false;
    if(stripeKey)
        stripePromise = loadStripe(stripeKey);
    const classes = useStyles();
    return (
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modal}
                open={payModal}
                onClose={closeModal}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={payModal}>
                    <div className={classes.paper}>
                        <h3 id="transition-modal-title">Pay Now ${parseFloat(payThisMuch).formatMoney()} USD</h3>
                        {stripePromise && <Elements stripe={stripePromise}>
                            <CheckoutForm
                                          setBilling={setBilling}
                                          billingDetails={billingDetails}
                                          sendStripeToken={sendStripeToken}/>
                        </Elements>}

                    </div>
                </Fade>
            </Modal>
    );
};

export default PaymentModal;